module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/doctor03-8850ebf7934b8bfd45a35923e1ab4643.png";